import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facet, FacetOption, FilterService, Product } from '@lobos/library';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.scss'],
})
export class ProductFilterComponent {
  @Input() facets!: Facet[] | null;
  @Input() product!: Product;
  @Input() totalHits!: number | null;
  @Output() facetChanged = new EventEmitter<FacetOption>();

  activeFacets$ = this.filterService.selectFilters();
  resetSelection: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(public filterService: FilterService) {}

  /** used to track the ngFor loop of facets */
  trackByFn(_: number, item: Facet) {
    return item?.key; // or item.id
  }

  resetFilter() {
    this.resetSelection.next(true);
    this.filterService.clearFilters();
  }

  multipleChoicesAvailable(facet: Facet): boolean {
    return facet.values && facet.values.length > 1;
  }
}
